import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
import axios from "@/http";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem("user")),
    answers: 0,
    todaysAnswers: 0,
    pageTitle: "",
    pageType: "",
    questionClasses: [],
    questionGroup: {},
    questionClass: {},
    questionSubject: {},
    profileExpanded: false,
    dictionary: [],
    totalProgress: 0.0,
    globalProgress: 0.0,
    totalCountedProgress: 0.0,
    curSolution: null,
    configureCar: false,
    popupMessage: null,
    popupMessageTitle: null,
    me: {},
    mute: false,
    helpMode: false,
    progress: {
      total: 0,
      daily: [],
      answers: 0,
    },
    subjects: [],
    analyticsOptOut: JSON.parse(localStorage.getItem("analytics-opt-out")),
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = { ...payload };
    },
    SET_CUR_SOLUTION(state, payload) {
      state.curSolution = { ...payload };
    },
    RESET_CUR_SOLUTION(state) {
      state.curSolution = null;
    },
    SET_ME(state, payload) {
      state.me = { ...payload };
    },
    SET_DICTIONARY(state, payload) {
      state.dictionary = payload;
    },
    LOGOUT(state) {
      state.user = null;
    },
    INC_ANSWERS(state, payload) {
      if (state.me && state.me.totalAnswers) {
        state.me.totalAnswers++;
      }
    },
    DEC_ANSWERS(state, payload) {
      state.answers--;
    },
    RESET_ANSWERS(state, payload) {
      state.answers = 0;
    },
    SET_ANSWERS(state, payload) {
      state.answers = payload;
    },
    SET_TODAYS_ANSWERS(state, payload) {
      state.todaysAnswers = payload;
    },
    INC_TODAYS_ANSWERS(state, payload) {
      state.todaysAnswers++;
    },
    SET_PAGE_TITLE(state, payload) {
      state.pageTitle = payload;
    },
    SET_PAGE_TYPE(state, payload) {
      state.pageType = payload;
    },
    SET_QUESTION_CLASSES(state, payload) {
      state.questionClasses = payload;
    },
    SET_CURRENT_QUESTION_GROUP(state, payload) {
      state.questionGroup = payload;
    },
    SET_CURRENT_QUESTION_CLASS(state, payload) {
      state.questionClass = payload;
    },
    SET_CURRENT_QUESTION_SUBJECT(state, payload) {
      state.questionSubject = payload;
    },
    SET_TOTAL_PROGRESS(state, payload) {
      state.totalProgress = payload;
    },
    SET_GLOBAL_PROGRESS(state, payload) {
      state.globalProgress = payload;
    },
    SET_TOTAL_COUNTED_PROGRESS(state, payload) {
      state.totalCountedProgress = payload;
    },
    INC_ANSWER_COUNT(state, payload) {
      for (let c of state.questionClasses) {
        if (c.slug === state.questionClass) {
          c.question_counts.answered++;
        }
        for (let g of c.subject_groups) {
          if (g.slug === state.questionGroup) {
            g.question_counts.answered++;
          }

          for (let s of g.subjects) {
            if (s.slug === state.questionSubject) {
              s.question_counts.answered++;
            }
          }
        }
      }
    },
    INC_EASY_ANSWER_COUNT(state, payload) {
      for (let c of state.questionClasses) {
        if (c.slug === state.questionClass) {
          c.question_counts.ll_answered++;
        }
        for (let g of c.subject_groups) {
          if (g.slug === state.questionGroup) {
            g.question_counts.ll_answered++;
          }

          for (let s of g.subjects) {
            if (s.slug === state.questionSubject) {
              s.question_counts.ll_answered++;
            }
          }
        }
      }
    },
    TOGGLE_PROFILE_EXPAND(state, payload) {
      state.profileExpanded = !state.profileExpanded;
    },
    PROFILE_EXPAND(state, payload) {
      state.profileExpanded = true;
    },
    PROFILE_RETRACT(state, payload) {
      state.profileExpanded = false;
    },
    SET_SUBJECTS(state, payload) {
      state.subjects = payload;
    },
    SET_CAR(state, payload) {
      state.me.meta.car.meta_value = payload;
    },
    SET_RIMS(state, payload) {
      state.rims = payload;
    },
    SET_CHARM(state, payload) {
      state.charm = payload;
    },
    SET_WINDOWS(state, payload) {
      state.windows = payload;
    },
    SET_COLOR(state, payload) {
      state.color = payload;
    },
    SET_CONFIGURE_CAR(state, payload) {
      state.configureCar = payload;
    },
    SET_MY_CAR(state, payload) {
      if (state.me && state.me.meta) {
        if (!state.me.meta.car) state.me.meta.car = {};
        state.me.meta.car.meta_value = payload;
      }
    },
    SET_POPUP_MESSAGE(state, payload) {
      state.popupMessage = payload;
    },
    SET_POPUP_MESSAGE_TITLE(state, payload) {
      state.popupMessageTitle = payload;
    },
    SET_HELP_MODE(state, payload) {
      state.helpMode = payload;
    },
    SET_MUTE(state, payload) {
      state.mute = payload;
    },
    SET_ANALYTICS_OPT_OUT(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    setUser({ commit }, user) {
      localStorage.setItem("user", JSON.stringify(user));
      commit("SET_USER", JSON.parse(JSON.stringify(user)));
    },
    setCurSolution({ commit }, question) {
      commit("SET_CUR_SOLUTION", question);
    },
    resetCurSolution({ commit }) {
      commit("RESET_CUR_SOLUTION");
    },
    setMe({ commit }, me) {
      //localStorage.setItem("user", JSON.stringify(user));
      commit("SET_ME", me);
    },
    setDictionary({ commit }, dict) {
      //localStorage.setItem("dictionary", JSON.stringify(dictionary));
      commit("SET_DICTIONARY", dict);
    },
    logout({ commit }) {
      localStorage.removeItem("user");
      firebase.auth().signOut();
      commit("LOGOUT");
    },
    incAnswers({ commit }) {
      commit("INC_ANSWERS");
      commit("INC_TODAYS_ANSWERS");
    },
    decAnswers({ commit }) {
      commit("DEC_ANSWERS");
    },
    setAnswers({ commit }, count) {
      commit("SET_ANSWERS", count);
    },
    setTodaysAnswers({ commit }, count) {
      commit("SET_TODAYS_ANSWERS", count);
    },
    incTodaysAnswers({ commit }, count) {
      commit("INC_TODAYS_ANSWERS");
    },
    resetAnswers({ commit }) {
      commit("RESET_ANSWERS");
    },
    setPageTitle({ commit }, title) {
      commit("SET_PAGE_TITLE", title);
    },
    setPageType({ commit }, type) {
      commit("SET_PAGE_TYPE", type);
    },
    setQuestionClasses({ commit }, questionClasses) {
      commit("SET_QUESTION_CLASSES", questionClasses);
    },
    setCurrentQuestionClass({ commit }, questionClass) {
      commit("SET_CURRENT_QUESTION_CLASS", questionClass);
    },
    setCurrentQuestionGroup({ commit }, questionGroup) {
      commit("SET_CURRENT_QUESTION_GROUP", questionGroup);
    },
    setCurrentQuestionSubject({ commit }, questionSubject) {
      commit("SET_CURRENT_QUESTION_SUBJECT", questionSubject);
    },
    incAnswerCount({ commit }) {
      commit("INC_ANSWER_COUNT");
    },
    setTotalProgress({ commit, progress }) {
      commit("SET_TOTAL_PROGRESS", progress);
    },
    setGlobalProgress({ commit, progress }) {
      commit("SET_GLOBAL_PROGRESS", progress);
    },
    setTotalCountedProgress({ commit, progress }) {
      commit("SET_TOTAL_COUNTED_PROGRESS", progress);
    },
    incEasyAnswerCount({ commit }) {
      commit("INC_EASY_ANSWER_COUNT");
    },
    toggleProfileExpanded({ dispatch, commit, getters }) {
      if (!getters.profileExpanded) {
        dispatch("loadMyData");
      }
      commit("TOGGLE_PROFILE_EXPAND");
    },
    expandProfile({ commit }) {
      commit("PROFILE_EXPAND");
    },
    retractProfile({ commit }) {
      commit("PROFILE_RETRACT");
    },
    setSubjects({ commit }, subjects) {
      commit("SET_SUBJECTS", subjects);
    },
    getSubjectBySlug({ commit, state }, slug) {
      let result = state.subjects.find((s) => s.slug == slug);
      return result;
    },
    setConfigureCar({ commit }, value) {
      commit("SET_CONFIGURE_CAR", value);
    },
    setMyCar({ commit }, value) {
      commit("SET_MY_CAR", value);
    },
    setPopupMessage({ commit }, value) {
      commit("SET_POPUP_MESSAGE", value);
    },
    setPopupMessageTitle({ commit }, value) {
      commit("SET_POPUP_MESSAGE_TITLE", value);
    },
    async loadMyData({ dispatch, commit, getters }) {
      if (getters.tokenHeader) {
        try {
          let result = await axios.get(
            process.env.VUE_APP_FLL_ROOT_API + "/me",
            {
              headers: {
                ...getters.tokenHeader,
              },
            }
          );

          if (!result.data.meta.car) {
            result.data.meta.car = {
              meta_value: {
                car: null,
                color: null,
                rims: null,
                windows: null,
                charm: null,
              },
            };
          }
          dispatch("setMe", result.data);
          dispatch("setAnswers", result.data.totalAnswers);
          dispatch("setTodaysAnswers", result.data.todaysAnswers);
          dispatch("setTotalProgress", result.data.totalProgress);
          dispatch("setTotalCountedProgress", result.data.totalCountedProgress);
        } catch (error) {
          // TODO: handle error
          console.error(error);  // eslint-disable-line
          dispatch("setMe", {});
        }
      }
    },
    setHelpMode({ commit }, value) {
      commit("SET_HELP_MODE", value);
    },
    toggleHelpMode({ commit, state }) {
      commit("SET_HELP_MODE", !state.helpMode);
    },
    setMute({ commit }, value) {
      commit("SET_MUTE", value);
    },
    toggleMute({ commit, state }) {
      commit("SET_MUTE", !state.mute);
    },
    setAnalyticsOptOut({ commit }, value) {
      localStorage.setItem("analytics-opt-out", JSON.stringify(true));
      commit("SET_ANALYTICS_OPT_OUT", value);
    },
  },
  getters: {
    token(state) {
      if (state.user !== null && state.user.hasOwnProperty("stsTokenManager")) {
        return state.user.stsTokenManager.accessToken;
      }
      return null;
    },
    tokenHeader(state) {
      if (state.user !== null && state.user.hasOwnProperty("stsTokenManager")) {
        if (
          state.user.stsTokenManager !== null &&
          state.user.stsTokenManager.hasOwnProperty("accessToken")
        ) {
          return { "Auth-Token": state.user.stsTokenManager.accessToken };
        }
      }
      return null;
    },
    user(state) {
      return state.user || null;
    },
    answers(state) {
      if (state.me && state.me.totalAnswers) {
        return state.me.totalAnswers;
      }
      return 0;
    },
    todaysAnswers(state) {
      let total = 0;
      if (state.me && state.me.todaysAnswers) {
        total += parseInt(state.me.todaysAnswers, 10);
      }
      return total + state.todaysAnswers;
    },
    totalProgress(state) {
      return state.totalProgress;
    },
    globalProgress(state) {
      return state.globalProgress;
    },
    totalCountedProgress(state) {
      return state.totalCountedProgress;
    },
    pageTitle(state) {
      return state.pageTitle;
    },
    questionClasses(state) {
      return state.questionClasses;
    },
    currentQuestionClass(state) {
      return state.questionClasses.find((c) => c.slug === state.questionClass);
    },
    currentQuestionGroup(state, getters) {
      if (
        !getters.currentQuestionClass ||
        !getters.currentQuestionClass.subject_groups
      ) {
        return;
      }

      if (getters.currentQuestionClass !== null) {
        return getters.currentQuestionClass.subject_groups.find(
          (g) => g.slug === state.questionGroup
        );
      }
    },
    currentQuestionSubject(state, getters) {
      if (
        !getters.currentQuestionGroup ||
        !getters.currentQuestionGroup.subjects
      ) {
        return;
      }

      if (getters.currentQuestionGroup !== null) {
        return getters.currentQuestionGroup.subjects.find(
          (s) => s.slug === state.questionSubject
        );
      }
    },
    pageType(state) {
      return state.pageType;
    },
    breadcrumbs(state, getters) {
      let result = [];
      switch (state.pageType) {
        case "questions-gw":
          result.push({ title: "Alle Kategorien ", link: "/" });
          if (getters.currentQuestionClass) {
            result.push({
              title: getters.currentQuestionClass.long_name,
              link: "/" + getters.currentQuestionClass.slug,
            });
          }
          if (getters.currentQuestionGroup) {
            result.push({
              title: getters.currentQuestionGroup.subject_group_name,
              link:
                "/" +
                getters.currentQuestionClass.slug +
                "/" +
                getters.currentQuestionGroup.slug,
            });
          }
          if (getters.currentQuestionSubject) {
            result.push({
              title: getters.currentQuestionSubject.subject_name,
              link:
                "/" +
                getters.currentQuestionClass.slug +
                "/" +
                getters.currentQuestionGroup.slug +
                "/" +
                getters.currentQuestionSubject.slug,
            });
          }
          break;
        case "questions-b":
          result.push({ title: "Fragen:", link: "/" });
          result.push({
            title: "Alle Kategorien B-Führerschein",
            link: "/b-fuehrerschein",
          });
          if (getters.currentQuestionSubject) {
            result.push({
              title: getters.currentQuestionSubject.subject_name,
              link: "/b-fuehrerschein/" + getters.currentQuestionSubject.slug,
            });
          }
          break;
        case "home":
          result.push({
            title: "F-EASY, dein Führerschein schnell und EASY",
            link: "/",
          });
          break;
        case "dictionary":
          //result.push({ title: "Home", link: "/" })
          result.push({ title: "Begriffe", link: "/begriffe" });
          break;
        case "login":
          //result.push({ title: "Home", link: "/" })
          result.push({ title: "Anmeldung", link: "/login" });
          break;
        case "question":
          //result.push({ title: "Home", link: "/" })
          result.push({ title: "Frage suchen", link: "/frage" });
          break;
        case "questions":
          //result.push({ title: "Home", link: "/" })
          result.push({ title: "Alle Fragen gemischt", link: "/fragen" });
          break;
        case "wrong-questions":
          //result.push({ title: "Home", link: "/" })
          result.push({
            title: "Meine falsch beantworteten Fragen",
            link: "/falsch-beantwortete",
          });
          break;
        case "hard-questions":
          //result.push({ title: "Home", link: "/" })
          result.push({ title: "Schwere Fragen", link: "/schwere-fragen" });
          break;
        case "5-point-questions":
          //result.push({ title: "Home", link: "/" })
          result.push({ title: "5-Punkte Fragen", link: "/5-punkte-fragen" });
          break;
        case "test":
          //result.push({ title: "Home", link: "/" })
          result.push({
            title: "Viel Glück bei der Prüfung",
            link: "/pruefung",
          });
          break;
        case "test-selection":
          //result.push({ title: "Home", link: "/" })
          result.push({
            title: "Viel Glück bei der Prüfung",
            link: "/pruefung",
          });
          break;
        case "imprint":
          result.push({ title: "Impressum", link: "/" });
          break;
      }
      return result;
    },
    me(state) {
      return state.me;
    },
    profileExpanded(state) {
      return state.profileExpanded;
    },
    dictionary(state) {
      return state.dictionary;
    },
    curSolution(state) {
      return state.curSolution;
    },
    subjects(state) {
      return state.subjects;
    },
    configureCar(state) {
      return state.configureCar;
    },
    myCar(state) {
      if (state.me && state.me.meta && state.me.meta.car) {
        if (state.me.meta.car.meta_value) return state.me.meta.car.meta_value;
      }
    },
    popupMessage(state) {
      return state.popupMessage;
    },
    popupMessageTitle(state) {
      return state.popupMessageTitle;
    },
    helpMode(state) {
      return state.helpMode;
    },
    mute(state) {
      return state.mute;
    },
    analyticsOptOut(state) {
      return state.analyticsOptOut;
    },
  },
});
